import * as React from 'react';
import { observer } from 'mobx-react';
import useStore from '@src/utils/hooks/use-store';
import MechaStore from '@src/pages/mecha/store';
import MechaMain from '@src/pages/mecha/sections/main';
import MechaWeapon from '@src/pages/mecha/sections/weapon';
import MechaMore from '@src/pages/mecha/sections/change-more';
import BackTopFooter from '@src/business-components/backtop-footer';
import cx from 'classnames';
import styles from './index.less';
import Page from '@src/components/page';

const Mecha = () => {
  /**
   * 首页 store
   * @type {MainStore}
   */
  const store = useStore(() => new MechaStore());

  return (
    <React.Fragment>
      <Page id="mecha-page" className={cx(styles.mecha_root, 'page-main')}>
        <div className={styles.macheContent}>
          <div className={styles.mecha_group_1} data-name="背景 ">
            <div className={styles.mecha_group_2} />
            {store.currentMechaMsg?.mecha_detail_gray_bg ? (
              <div className={styles.mecha_group_3} data-name="底纹" style={{ backgroundImage: `url(${store.currentMechaMsg.mecha_detail_gray_bg})` }} />
            ) : null}
            <div className={styles.mecha_layer_8} />
          </div>
          <MechaMain store={store.main} />
          <MechaWeapon store={store.weapon} />
          <MechaMore store={store.more} />
        </div>
        <BackTopFooter theme="light" />
      </Page>
    </React.Fragment>
  );
};

export default observer(Mecha);
